import Index from '@/pages/recording/Index'

export default {
  path: 'log',
  component: Index
}